function BindInputMasks($context: JQuery<HTMLElement>): void {
    // Phone masks
    $context.find('.phone-mask').inputmask({
        mask: '(999) 999-9999',
        autoUnmask: true,
        clearMaskOnLostFocus: true,
        removeMaskOnSubmit: true
    });

    $context.find('.phone-10-mask').inputmask({
        mask: '9999999999',
        autoUnmask: true,
        clearMaskOnLostFocus: true
    });

    // SSN
    $context.find('.ssn-mask').inputmask({
        mask: '999-99-9999',
        autoUnmask: true,
        clearMaskOnLostFocus: true,
        removeMaskOnSubmit: true
    });

    // Email
    $context.find('.email-mask').inputmask({
        alias: 'email'
    });

    // Zip
    $context.find('.zipcode-mask').inputmask({
        mask: '99999[-9999]',
        clearIncomplete: true
    });

    // Zip
    $context.find('.zipcode5only-mask').inputmask({
        mask: '99999',
        clearIncomplete: true
    });

    // Date
    $context.find('.date-mask').inputmask({
        alias: 'datetime',
        inputFormat: 'mm/dd/yyyy'
    });

    $context.find('.date-mask').datepicker({
        todayBtn: "linked"
    });

    // Month/Year picker
    const $monthYear = $context.find('.dateMonthYear-mask');

    $monthYear.prop('readonly', true);

    $monthYear
        .datepicker({
            format: "mm/yyyy",
            startView: "months",
            minViewMode: "months",
            autoclose: true
        })
        .on('changeDate', function (e: any): void {
            const selected: Date = e.date;

            const month = (selected.getMonth() + 1).toString().padStart(2, '0');
            const year = selected.getFullYear();

            const display = `${month}/${year}`;
            const fullValue = `${month}/01/${year} 00:00:00`;

            const $input = $(this);
            $input.val(display);
            $input.data('fullvalue', fullValue);
        });

    // Initialize existing values
    $monthYear.each(function (): void {
        const $input = $(this);
        const val = $input.val() as string | undefined;

        if (!val) {
            return;
        }

        const date = new Date(val);

        if (isNaN(date.getTime())) {
            return;
        }

        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        const display = `${month}/${year}`;
        const fullValue = `${month}/01/${year} 00:00:00`;

        $input.val(display);
        $input.data('fullvalue', fullValue);
    });

    // Money
    $context.find('.money-mask').inputmask({
        alias: 'numeric',
        groupSeparator: ',',
        autoGroup: true,
        digits: 2,
        digitsOptional: false,
        prefix: '$',
        placeholder: '0',
        rightAlign: false,
        autoUnmask: true,
        clearMaskOnLostFocus: false
    });

    // Integer
    $context.find('.integer-mask').inputmask({
        alias: 'integer',
        rightAlign: false
    });

    // Decimal
    $context.find('.decimal-mask').inputmask({
        alias: 'decimal',
        rightAlign: false
    });

    //StateCode
    $context.find('.stateCode-mask').inputmask({
        mask: "aa",
        casing: "upper"
    });
}

function GetFormDataUnMasked(form: HTMLFormElement): FormData {

    const $form = $(form);

    // KEEP native browser file handling
    const formData = new FormData(form);

    // -----------------------------------------
    // REMOVE values from nested .gridBinder
    // -----------------------------------------

    $form.find('.gridBinder')
        .find('input, select, textarea')
        .each((_, el) => {

            const input = el as HTMLInputElement;

            if (!input.name) return;

            formData.delete(input.name);
        });

    // -----------------------------------------
    // UNMASK values in current grid scope
    // -----------------------------------------

    $form.findInGrid('input.phone-mask, input.money-mask')
        .each((_, el) => {

            const input = el as HTMLInputElement;
            const $input = $(input);

            if (!input.name) return;

            const unmasked = $input.inputmask('unmaskedvalue');

            if (unmasked !== undefined) {
                formData.set(input.name, unmasked);
            }
        });

    return formData;
}